/*
 * Shim for Shopify's platform-hosted option_selection.js, which the layouts
 * load via `shopify_asset_url` immediately before this file.
 *
 * On 2026-09-04 Shopify redeployed that script wrapped in "use strict" while
 * Shopify.Product.prototype.update still used an undeclared loop variable
 * (`for (property in json)`). In strict mode that throws
 * "ReferenceError: property is not defined" from inside
 * `new Shopify.OptionSelectors(...)`, which aborts this theme's product init:
 * no price, no variant dropdowns, no add-to-cart binding.
 *
 * This file probes for that exact failure and, only if it is present, replaces
 * the one broken method with the same logic and a declared variable. When
 * Shopify ships a corrected build the probe passes and this file does nothing.
 * Safe to delete once Shopify's script is fixed.
 */
(function () {
  var S = window.Shopify;
  if (!S || typeof S.Product !== 'function' || !S.Product.prototype) return;
  try {
    new S.Product({ __shimProbe: 1 });
    return; // healthy build, nothing to do
  } catch (e) {
    if (!(e instanceof ReferenceError)) return; // different failure; leave it alone
  }
  S.Product.prototype.update = function (json) {
    for (var key in json) {
      this[key] = json[key];
    }
  };
})();
